const DEFAULT_STATE = {};

export default function reducer(state, action) {
    if (!state) {
        state = {...DEFAULT_STATE};
    }

    switch (action.type) {
        case 'ONCE_RESET_ALL':
            state = {...DEFAULT_STATE};
            break;
        case 'ONCE_RESET_COLLECTION':
            state = {
                ...state,
                [action.collection]: [],
            };
            break;
        case 'ONCE_TOUCH':
            state = {
                ...state,
                [action.collection]: [...(action.collection || []), action.id],
            };
            break;
    }

    return state;
}
